import type { ClerkProviderProps } from "@clerk/react";

// Clerk appearance object matching the PriceWatch Mantine 8 theme.
// Applied at ClerkProvider level so all Clerk components inherit the theme.
export const clerkAppearance: ClerkProviderProps["appearance"] = {
  variables: {
    colorPrimary: "#228be6",
    colorBackground: "#ffffff",
    colorForeground: "#212529",
    colorMutedForeground: "#868e96",
    colorNeutral: "#ced4da",
    colorDanger: "#fa5252",
    colorInput: "#ffffff",
    colorBorder: "#dee2e6",
    colorRing: "#228be6",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    fontSize: "0.875rem",
    borderRadius: "0.5rem",
    spacing: "1rem",
  },
};
